import { createRouter, createWebHistory } from 'vue-router'

  const routes = [
  {
    path: '/',
    name: 'AccountHome',
    //component: Signin
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue')
  },
  {
    path: '/index.html',
    name: 'AccountIndex',
    //component: Signin
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue')
  },  
  {
    path: '/signin',
    name: 'AccountSignin',
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue')
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "resetpassword" */ '../views/ResetPassword.vue')
  },  
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
  },  
  { 
    path: '/:pathMatch(.*)*', 
    name: 'AccountPageNotFound',
    component: () => import('../views/PageNotFound.vue') 
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
